module.exports = __webpack_public_path__ + "img/1440016709.0dc8d510.jpg";